<template>
  <div class="app-icon-menu-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppIconMenuGroup',
};
</script>

<style lang="scss" scoped>
.app-icon-menu-group {
  display: flex;
  flex-wrap: wrap;
  & > * {
    width: 20%;
  }
}
</style>
